/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Entity_Companycountry1Inputs */

const en_entity_companycountry1 = /** @type {(inputs: Entity_Companycountry1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Company Country`)
};

const de_entity_companycountry1 = /** @type {(inputs: Entity_Companycountry1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Firmenland`)
};

/**
* | output |
* | --- |
* | "Company Country" |
*
* @param {Entity_Companycountry1Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const entity_companycountry1 = /** @type {((inputs?: Entity_Companycountry1Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Entity_Companycountry1Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_entity_companycountry1(inputs)
	return de_entity_companycountry1(inputs)
});
export { entity_companycountry1 as "entity_companyCountry" }